module.exports = __webpack_public_path__ + "static/media/lucas-t.22dff533.png";